/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Gl_14_DInputs */

const en_tut_gl_14_d = /** @type {(inputs: Tut_Gl_14_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A read-only agent belonging to one member that answers as needed while that member is unavailable.`)
};

const id_tut_gl_14_d = /** @type {(inputs: Tut_Gl_14_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen baca-saja milik satu anggota yang menjawab seperlunya saat anggota itu sedang tidak tersedia.`)
};

/**
* | output |
* | --- |
* | "A read-only agent belonging to one member that answers as needed while that member is unavailable." |
*
* @param {Tut_Gl_14_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_gl_14_d = /** @type {((inputs?: Tut_Gl_14_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Gl_14_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_gl_14_d(inputs)
	return en_tut_gl_14_d(inputs)
});